import {
  VStack,
  HStack,
  Text,
  Button,
  NumberInput,
  type NumberInputValueChangeDetails,
} from '@chakra-ui/react';

interface Props {
  availableCanvasserCount: number
  targetDate: string
  recutTurfCount: number
  onRecutTurfCountChange: (val: number) => void
  onCancel: () => void
  onGenerate: () => void
  isLoading: boolean
}

export function TurfRecutDialog({
  availableCanvasserCount, targetDate, recutTurfCount, onRecutTurfCountChange,
  onCancel, onGenerate, isLoading,
}: Props) {
  return (
    <VStack
      position="absolute" top={0} left={0} right={0} bottom={0}
      bg="gray.50" borderRadius="lg" zIndex={20}
      justify="center" gap={4}
    >
      <Text fontWeight="medium">Auto Re-Cut</Text>
      <Text fontSize="sm" color="gray.600">
        {availableCanvasserCount} canvassers available for {targetDate}
      </Text>
      <HStack gap={3}>
        <Text fontSize="sm">Number of turfs:</Text>
        <NumberInput.Root
          size="sm"
          min={1}
          max={Math.max(availableCanvasserCount * 2, 20)}
          value={String(recutTurfCount)}
          onValueChange={(details: NumberInputValueChangeDetails) => onRecutTurfCountChange(details.valueAsNumber || 1)}
          w="80px"
        >
          <NumberInput.Input />
          <NumberInput.Control>
            <NumberInput.IncrementTrigger />
            <NumberInput.DecrementTrigger />
          </NumberInput.Control>
        </NumberInput.Root>
      </HStack>
      <HStack gap={3}>
        <Button size="sm" variant="outline" onClick={onCancel}>
          Cancel
        </Button>
        <Button
          size="sm"
          colorPalette="brand"
          onClick={onGenerate}
          loading={isLoading}
        >
          Generate Preview
        </Button>
      </HStack>
    </VStack>
  );
}
